// extracted by css-extract-rspack-plugin
export default {"TickList":"TickList-Cna744","tickList":"TickList-Cna744","TickListItem":"TickListItem-uI1r8c","tickListItem":"TickListItem-uI1r8c"};